<!--
 `(submit)="false"` prevents the default form action, which would reload the
 page.
-->
<form class="form-horizontal" novalidate (submit)="(false)">
  <ng-content></ng-content>
</form>
